import React from "react";
import { profile } from "../content";

export const Loader = () => (
  <div className="loader" role="status" aria-live="polite">
    <span className="loader-mark">
      {profile.name}
      <span className="wordmark-dot" style={{ display: "inline-block" }} />
    </span>
    <span className="loader-bar">
      <span />
    </span>
    <span className="visually-hidden">Loading</span>
  </div>
);

export default Loader;
